import React, { useState } from "react";
import Pagination from "@mui/material/Pagination";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

import "../../assets/style/tablesG.css";

import { iniCargarPptos } from "../../redux/actions/pptos";

/* import { CardTotalClienteList } from "../pptos/form/CardTotalClienteList";
 */ // import { CardGastoRList } from "../pptos/form/CardGastoRList"
// import { CardUtilidadRealList } from "../pptos/form/CardUtilidadRealList"
// import { CardUtilidadFinalList } from "../pptos/form/CardUtilidadFinalList"
import { Tooltip } from "@mui/material";
/* import { CardTotalFacturado } from "../pptos/form/CardTotalFacturado";
import { CardTotalPorFacturar } from "../pptos/form/CardTotalPorFacturar"; */
import { CardPrices } from "../reusableUI/v2UI/CardsPrices";

export const TableListAprobadoPorFacturar = ({ filters, setFilters }) => {
  const dispatch = useDispatch();

  const { access } = useSelector((state) => state.auth);
  const paramsGeneral = useSelector((state) => state.general);
  // const paramsDetail = paramsGeneral.detail;
  const info = paramsGeneral.info;

  const statePpto = useSelector((state) => state.ppto);
  const { list } = statePpto;

  const {
    soles_total_final_venta,
    soles_total_facturado,
    soles_total_por_facturar,
    separacion_miles = info?.local_separacion_miles,
    separacion_decimales = info?.local_separacion_decimales,
    simbolo = info?.local_simbolo,
    cantidad = 0,
  } = statePpto.totales;

  const [page, setPage] = useState(1);

  const handleChange = (event, value) => {
    // console.log(value);
    setPage(value);
    const newFilters = {
      ...filters,
      page: value,
    };
    setFilters(newFilters);
    dispatch(iniCargarPptos(newFilters));
  };

  return (
    <>
      {/* <div className="row mt-3">
        <div className="col">
          <CardTotalClienteList params={paramsDetail} />
        </div>
        <div className="col">
          <CardTotalFacturado params={paramsDetail} />
        </div>
        <div className="col">
          <CardTotalPorFacturar params={paramsDetail} />
        </div>
      </div> */}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-3">
        <CardPrices
          title="TOTAL VENTA"
          total={soles_total_final_venta}
          percent={0}
          label="Monto neto aprobado"
          bgColor="bg-black-500"
          textColor="text-black-500"
          formatMoney={{
            thousandSeparator: separacion_miles,
            decimalSeparator: separacion_decimales,
            prefix: simbolo,
          }}
          hasProgress={false}
        />

        <CardPrices
          title="TOTAL FACTURADO"
          total={soles_total_facturado}
          percent={
            soles_total_facturado
              ? (soles_total_facturado / soles_total_final_venta) * 100
              : 0
          }
          label="del total venta neta"
          bgColor="bg-red-600"
          textColor="text-red-600"
          formatMoney={{
            thousandSeparator: separacion_miles,
            decimalSeparator: separacion_decimales,
            prefix: simbolo,
          }}
        />

        <CardPrices
          title="TOTAL POR FACTURAR"
          total={soles_total_por_facturar}
          percent={
            soles_total_por_facturar
              ? (soles_total_por_facturar / soles_total_final_venta) * 100
              : 0
          }
          label="del total venta neta"
          bgColor="bg-green-600"
          textColor="text-green-600"
          formatMoney={{
            thousandSeparator: separacion_miles,
            decimalSeparator: separacion_decimales,
            prefix: simbolo,
          }}
        />
      </div>

      <div className="p-table">
        <div className="flex justify-between items-center">
          {cantidad > 0 ? (
            <div className="ms-2 text-gray-500">
              {cantidad || 0} proyectos encontrados
            </div>
          ) : (
            <div></div>
          )}

          <Pagination
            count={10}
            page={page}
            size="small"
            onChange={handleChange}
          />
        </div>

        <div className="table-responsive">
          <table className="table p-table-global">
            <thead className="p-thead-global">
              <tr className="text-center">
                <th style={{ color: "#595759" }}>Número</th>
                <th style={{ color: "#595759" }}>Fecha</th>
                <th style={{ color: "#595759" }}>Ejecutivo</th>
                <th className="text-start" style={{ color: "#595759" }}>
                  Referencia
                </th>
                <th className="text-start" style={{ color: "#595759" }}>
                  Cliente
                </th>
                <th style={{ color: "#595759" }}>Total Neto</th>
                {access.a10 && (
                  <>
                    <th
                      style={{
                        borderLeft: "1px solid lightgray",
                        color: "#595759",
                      }}
                    >
                      Facturado
                    </th>
                    <th style={{ color: "#595759" }}>Por facturar</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {list.map((p) => (
                <tr className="p-tr-body-global" key={p.id}>
                  <td className="text-center align-bottom">
                    <Link className="LinkTable" to={`/ppto/${p.id}`}>
                      #{p.numero}
                    </Link>
                  </td>
                  <td
                    className="text-center align-bottom"
                    title={moment(p.fecha_asignacion).format("DD-MM-YYYY")}
                  >
                    <Link className="LinkTable" to={`/ppto/${p.id}`}>
                      {moment(p.fecha_asignacion).format("MMM YYYY")}
                    </Link>
                  </td>
                  <td>
                    <Link className="LinkTable" to={`/ppto/${p.id}`}>
                      <div className="row photo">
                        <div className="col d-flex justify-content-center">
                          <div className="d-flex justify-content-center align-items-center p-container-foto">
                            <Tooltip
                              title={`${p.ejecutivo_nombre}${" "}${p.ejecutivo_apellidos}`}
                            >
                              <span>
                                {p.ejecutivo_nombre
                                  ? p.ejecutivo_nombre.substring(0, 1)
                                  : ""}
                                {p.ejecutivo_apellidos
                                  ? p.ejecutivo_apellidos.substring(0, 1)
                                  : ""}
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </td>
                  <td
                    className="text-clientes text-start align-bottom"
                    style={{ position: "relative" }}
                  >
                    <Link className="LinkTable" to={`/ppto/${p.id}`}>
                      {p.referencia || "---"}
                    </Link>
                  </td>
                  <td className="text-clientes text-start align-bottom">
                    <Link className="LinkTable" to={`/ppto/${p.id}`}>
                      {p.cliente || "---"}
                    </Link>
                  </td>

                  {/* venta */}
                  <td className="text-center align-bottom p-bg-col-ventas">
                    <Link className="LinkTable" to={`/ppto/${p.id}`}>
                      <div className="p-numbers-list">
                        <NumberFormat
                          value={p.total_neto ? parseFloat(p.total_neto) : 0}
                          displayType={"text"}
                          thousandSeparator={p.separacion_miles}
                          decimalSeparator={p.separacion_decimales}
                          decimalScale={2}
                          prefix={`${p.simbolo}`}
                          fixedDecimalScale
                        />
                      </div>
                    </Link>
                  </td>
                  {access.a10 && <FacturacionInfo p={p} />}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const FacturacionInfo = ({ p }) => {
  return (
    <>
      <td
        className="text-end align-bottom"
        style={{ borderLeft: "1px solid lightgray" }}
      >
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          <div className="p-numbers-list">
            <NumberFormat
              value={p.total_facturado ? parseFloat(p.total_facturado) : 0}
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo}`}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
      <td className="text-end align-bottom">
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          {/* <div style={{ fontSize: '11px' }}>
                        <NumberFormat
                            value={p.total_facturado ? ((parseFloat(p.total_facturado) / parseFloat(p.total_neto)) * 100) : 0}
                            displayType={'text'}
                            thousandSeparator={','}
                            decimalSeparator='.'
                            decimalScale={2}
                            suffix="%"
                            fixedDecimalScale
                        />
                    </div> */}
          <div className="p-numbers-list">
            <NumberFormat
              value={
                p.total_por_facturar ? parseFloat(p.total_por_facturar) : 0
              }
              displayType={"text"}
              thousandSeparator={p.separacion_miles}
              decimalSeparator={p.separacion_decimales}
              decimalScale={2}
              prefix={`${p.simbolo}`}
              fixedDecimalScale
            />
          </div>
        </Link>
      </td>
    </>
  );
};
